import { EdgeProps, getSmoothStepPath } from 'reactflow';
import styled from 'styled-components';

const Path = styled.path<{ $isSelected: boolean; $marker?: string }>`
  stroke-width: 2;
  stroke: ${({ $isSelected, theme: { global, editor } }) =>
    $isSelected ? global.mainColor : editor.edgeColor} !important;
`;

const PolyLine = styled.polyline<{ $isSelected?: boolean }>`
  ${({ $isSelected, theme: { global, editor } }) => {
    if ($isSelected) {
      return {
        stroke: global.mainColor,
        fill: global.mainColor,
      };
    }
    return {
      stroke: editor.edgeColor,
      fill: editor.edgeColor,
    };
  }}
`;

const BasePath = styled.path`
  stroke: transparent !important;
  stroke-width: 20;
`;

interface SmoothStepEdgeProps extends EdgeProps {}

const SmoothStepEdge = (props: SmoothStepEdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    sourcePosition: props.sourcePosition,
    targetX: props.targetX,
    targetY: props.targetY,
    targetPosition: props.targetPosition,
  });
  const markerId = `${props.id}__marker`;

  return (
    <>
      <defs>
        <marker
          id={markerId}
          className="react-flow__arrowhead"
          markerWidth="20"
          markerHeight="20"
          viewBox="-10 -10 20 20"
          markerUnits="strokeWidth"
          orient="auto-start-reverse"
          refX="0"
          refY="0"
        >
          <PolyLine
            $isSelected={props.selected}
            strokeLinecap="round"
            strokeLinejoin="round"
            points="-4,-3 0,0 -4,3 -4,-3"
          ></PolyLine>
        </marker>
      </defs>
      <BasePath id={props.id} className="react-flow__edge-path" d={edgePath} />
      <Path
        markerEnd={`url(#${markerId})`}
        id={props.id}
        className="react-flow__edge-path"
        d={edgePath}
        $isSelected={props.selected!}
      />
    </>
  );
};

export default SmoothStepEdge;
